<template>
  <div>
    <b-navbar toggleable="lg" style="background-color: #6d9eeb; color:whitesmoke">
      <b-navbar-brand
          style="cursor:pointer;"
          @click="handleChangeViewState('plan')"
      >
        Living Care Plan
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse">
      </b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-button-toolbar key-nav aria-label="Toolbar with button groups">
            <b-button-group class="mx-1">
              <b-button
                  variant="outline-primary"
                  size="md"
                  class="my-2 my-md-0"
                  @click="handleOpenExportModal('copy')"
                  style="margin: 10px"
              >
                <b-icon icon="clipboard"></b-icon>
              </b-button>
              <b-button
                  variant="outline-primary"
                  size="md"
                  class="my-2 my-md-0"
                  :disabled="true"
                  @click="handleOpenExportModal('print')"
                  style="margin: 10px"
              >
                <b-icon icon="printer"></b-icon>
              </b-button>
              <b-button
                  variant="outline-primary"
                  size="md"
                  class="my-2 my-md-0"
                  @click="handleOpenExportModal('pdf')"
                  style="margin: 10px"
              >
                <b-icon icon="cloud-download"></b-icon>
              </b-button>
              <b-button
                  variant="outline-primary"
                  size="md"
                  class="my-2 my-md-0"
                  @click="handleOpenExportModal('email')"
                  style="margin: 10px"
              >
                <b-icon icon="envelope"></b-icon>
              </b-button>
            </b-button-group>
          </b-button-toolbar>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

  </div>
</template>

<script>
export default {
  name: "CarePlan_NavBar",
  components: {},
  props: {
    profile: {
      type: Object,
      default: () => {
        return {}
      }
    },
    session: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  mounted() {},
  computed: {},
  methods: {
    handleNewPlanClick() {
      this.$emit('new-plan-click');
    },
    handleOpenExportModal(exportTypeId) {
      this.$emit("open-export-modal", exportTypeId);
    }
  },
  data() {
    return { };
  }
};
</script>

<style lang="scss" scoped>
.header__close {
  position: relative;
  padding-bottom: 8px;
  &.border-none::after {
    content: none !important;
  }
  .ico {
    position: absolute;
    top: 5px;
    right: 13px;
    cursor: pointer;
  }
  .ico__search {
    right: unset !important;
    left: 13px;
  }
  h3 {
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 36px;
    line-height: 49px;
    text-align: center;

    color: #5b606c;
  }
  &::after {
    content: "";
    position: absolute;
    top: 100%;
    width: 100%;
    border-bottom: 1px solid #e4e6eb;
  }
}
.upload-btn {
  cursor: pointer;
  background-color: #fff;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  max-width: 220px;
  height: 50px;
  border: none;
  letter-spacing: 0.05em;
  align-items: center;
  color: var(--theme-color);
  margin-left: 16px;
  border-radius: 4px;
  transition: all 0.2s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  .content {
    display: flex;
    #blogger-publishing-video {
      width: 0;
    }
    #guide-publishing-image {
      width: 0;
    }
    .ico {
      margin-right: 3px;
      img {
        cursor: pointer;
        position: relative;
        top: 50%;
        right: 4px;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        height: 24px;
        width: 24px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        background: rgba(85, 126, 251, 0.1);
        border-radius: 8px;
      }
      svg {
        height: 30px;
      }
    }
    .watch-video {
      margin-top: 5px;
    }
    .btn-content {
      margin-top: 2px;
      font-family: Nunito;
      font-style: normal;
      font-size: 16px;
      line-height: 22px;
      color: var(--theme-color);
    }
  }
}
.upload-btn:focus {
  outline: none;
  box-shadow: none;
}
</style>
